import { Navigate, useRoutes } from "react-router-dom";
import { Suspense } from "react";
// config

import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";
import { ROUTES } from "@/core/router/routes";
import { useAuth } from "@/core/context/AuthContext";
import NotFoundPage from "@/features/not-found/not-found-page";
import { lazy } from "react";
import InvitePage from "@/features/invite/pages/invite/invite-page";
import WorkspaceInvitePage from "@/features/invite/pages/workspace-invite/workspace-invite-page";

// ----------------------------------------------------------------------

const SharePage = lazy(() => import("@/features/share/pages/share/share-page"));
const ProductAnswersInvitePage = lazy(
  () =>
    import(
      "@/features/dashboard/pages/specification/pages/product-answers/invite/invite"
    )
);
const RegardPage = lazy(
  () =>
    import(
      "@/features/dashboard/pages/specification/pages/product-answers/invite/regard-page"
    )
);
const PrivacyPolicyPage = lazy(
  () => import("@/features/legal/pages/privacy-policy/privacy-policy-page")
);
const TermsOfServicePage = lazy(
  () => import("@/features/legal/pages/terms-of-service/terms-of-service-page")
);

export default function Router() {
  const { isAuthenticated } = useAuth();

  const PATH_AFTER_LOGIN = isAuthenticated
    ? `/${ROUTES.Dashboard.Root}`
    : `/${ROUTES.Auth.Root}/${ROUTES.Auth.SignIn}`;

  return useRoutes([
    // Root yönlendirmesini aktif hale getiriyoruz
    {
      path: "/",
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // No match 404
    { path: "*", element: <Navigate to="/404" replace /> },
    { path: "/404", element: <NotFoundPage /> },
    {
      path: "/share",
      element: (
        <Suspense
          fallback={
            <div className="h-screen w-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          }
        >
          <SharePage />
        </Suspense>
      ),
    },
    { path: "/invite", element: <InvitePage /> },
    { path: "/workspace-invite", element: <WorkspaceInvitePage /> },
    {
      path: ROUTES.Dashboard.Specification.ProductAnswersInvite,
      element: (
        <Suspense
          fallback={
            <div className="h-screen w-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          }
        >
          <ProductAnswersInvitePage />
        </Suspense>
      ),
    },
    {
      path: ROUTES.Dashboard.Specification.Regard,
      element: (
        <Suspense
          fallback={
            <div className="h-screen w-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          }
        >
          <RegardPage />
        </Suspense>
      ),
    },
    {
      path: "/privacy-policy",
      element: (
        <Suspense
          fallback={
            <div className="h-screen w-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          }
        >
          <PrivacyPolicyPage />
        </Suspense>
      ),
    },
    {
      path: "/terms-of-service",
      element: (
        <Suspense
          fallback={
            <div className="h-screen w-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          }
        >
          <TermsOfServicePage />
        </Suspense>
      ),
    },
  ]);
}
